export const inputs = [
  {
    label: "İsim ve Soyisim",
    image: "/person.svg",
    type: "text",
    placeholder: "İsim ve Soyisim",
    name: "name",
    visibleIn: ["kayit"],
  },
  {
    label: "Mail Adresi",
    image: "/mail.svg",
    type: "email",
    placeholder: "Mail adresiniz",
    name: "email",
    visibleIn: ["kayit", "giris"],
  },
  {
    label: "Giriş Şifresi",
    image: "/lock-closed.svg",
    type: "password",
    placeholder: "Giriş şifresi belirleyiniz",
    name: "password",
    visibleIn: ["kayit"],
  },
  {
    label: "Giriş Şifresi",
    image: "/lock-closed.svg",
    type: "password",
    placeholder: "Giriş şifreniz",
    name: "password",
    visibleIn: ["giris"],
  },
  {
    label: "Kariyer Yolculuğunda Hangi Noktadasın?",
    image: "",
    type: "select",
    name: "type",
    options: [
      { value: "JUNIOR", label: "Junior" },
      { value: "SENIOR", label: "Senior" },
    ],
    defaultValue: "Junior",
    visibleIn: ["kariyer_bilgileri"],
  },
  {
    label: "E-posta",
    image: "/mail.svg",
    type: "email",
    placeholder: "Lütfen e-posta adresinizi girin",
    name: "email",
    visibleIn: ["sifre-yenileme"],
  },
  {
    label: "Yeni Şifre",
    image: "/lock-closed.svg",
    type: "password",
    placeholder: "Yeni Şifre Belirle",
    name: "password",
    visibleIn: ["yeni-sifre-belirle"],
  },
];
